import { WithPermissions } from '@Components/common/with-permissions.tsx'
import { AuthScopes, CouponAssignmentWithPromotion } from '@Generated/back-office-client/src'
import { Button, Flex } from '@radix-ui/themes'
import { PlayerServiceAPI } from '@API/data-services/player-service.ts'
import { useMutation } from '@tanstack/react-query'
import { ViewCouponModal } from '@Components/tools/player/view-coupon-modal.tsx'

export const CouponBarcode = ({ coupon }: { coupon: CouponAssignmentWithPromotion }) => {
  const {
    mutate: getCouponImage,
    data: couponImage,
    isPending,
  } = useMutation({
    mutationFn: async ({ promotionId, couponId }: { promotionId: string; couponId: string }) => {
      return await PlayerServiceAPI.getCouponImage(promotionId, couponId)
    },
  })

  return (
    <Flex>
      {couponImage ? <ViewCouponModal couponImageBlob={couponImage} /> : null}
      <Flex justify="start" className="scan-barcode-cell">
        <WithPermissions requiredPermissions={AuthScopes.readbarcodes}>
          <Button
            className="scan-table-button"
            loading={isPending}
            onClick={() =>
              getCouponImage({ promotionId: coupon.promotionId, couponId: coupon.couponId })
            }>
            View
          </Button>
        </WithPermissions>
        *****{coupon.truncatedBarcode}
      </Flex>
    </Flex>
  )
}
